import React from "react";
import EnrollmentModal from "./EnrollmentModal";
import { closeEnrollmentModal, useEnrollmentTrigger } from "./store";

export const EnrollmentModalHost: React.FC = () => {
  const trigger = useEnrollmentTrigger();
  if (!trigger) return null;
  return <EnrollmentModal trigger={trigger} onClose={closeEnrollmentModal} />;
};

export { openEnrollmentModal, closeEnrollmentModal } from "./store";
